var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-text',{staticClass:"ml-4 font-weight-bold"},[_vm._v(_vm._s(_vm.clockStr))])
}
var staticRenderFns = []

export { render, staticRenderFns }